import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import * as React from "react";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { queryConfig } from "../lib/react-query";
import { AssetPreloader } from "./AssetPreloader";

type AppProviderProps = {
  children: React.ReactNode;
};

// Simple fallback component that doesn't use useNavigate
const ErrorFallback = () => (
  <div className="flex h-screen w-screen items-center justify-center">
    <div className="text-center">
      <h1 className="text-2xl font-bold mb-4">Something went wrong</h1>
      <p className="text-gray-600">Please refresh the page to try again.</p>
    </div>
  </div>
);

export const AppProvider = ({ children }: AppProviderProps) => {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: queryConfig,
      })
  );

  return (
    <Suspense
      fallback={
        <div className="flex h-screen w-screen items-center justify-center">
          <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-gray-900"></div>
        </div>
      }
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <QueryClientProvider client={queryClient}>
          <AssetPreloader />
          {children}
        </QueryClientProvider>
      </ErrorBoundary>
    </Suspense>
  );
};
